var version = {
    "name":      "dativery",
    "buildDateCode": "20260302-113012",
    "buildDate": "Mon Mar 02 2026 11:30:12 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260302-113012",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;